import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { ImpactPageDataQuery, ImpactPageDataQueryVariables } from './impactPageData.graphql';
import { ImpactPageData } from './impactPageData.graphql';

type ImpactPageDataParams = { locale: string; countryCode: string };

export async function getImpactPageData(
	{ gql: { fetch } }: UtilityContext,
	{ countryCode, locale }: ImpactPageDataParams,
): Promise<ImpactPageDataQuery> {
	const { data } = await fetch<ImpactPageDataQuery, ImpactPageDataQueryVariables>({
		query: ImpactPageData,
		variables: { locale, countryCode },
		rejectOnError: true,
	});

	return data;
}
